import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Volume2, VolumeX, Play } from 'lucide-react';
import { videoFileUrl, trackVideo, useCaptionsTrack } from './MediaVideos';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Homepage hero: featured promo autoplays muted with captions on; one tap for sound.
export const HeroVideo = () => {
  const [v, setV] = useState(null);
  const [muted, setMuted] = useState(true);
  const ref = useRef();
  useEffect(() => { axios.get(`${API}/media/videos/featured`).then((r) => setV(r.data || null)).catch(() => {}); }, []);
  useEffect(() => { if (v && ref.current) ref.current.play().catch(() => {}); }, [v]);
  useCaptionsTrack(ref, v);
  if (!v) return null;

  const toggleSound = () => {
    const el = ref.current; if (!el) return;
    el.muted = !el.muted; setMuted(el.muted);
    if (!el.muted) { el.currentTime = 0; el.play().catch(() => {}); if (!el.dataset.counted) { el.dataset.counted = '1'; trackVideo(v, 'play'); } }
  };

  return (
    <div className="relative w-full" data-testid="hero-video">
      <div className="absolute -inset-3 bg-gradient-to-r from-brand-blue to-brand-teal rounded-2xl opacity-25 blur-2xl" />
      <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-black">
        <video
          ref={ref} muted loop autoPlay playsInline preload="auto" crossOrigin="anonymous"
          poster={v.poster || undefined} src={videoFileUrl(v)}
          className="w-full aspect-video object-cover" data-testid="hero-video-player"
        />
        <button type="button" onClick={toggleSound} aria-label={muted ? 'Turn sound on' : 'Mute'} data-testid="hero-video-sound-btn"
          className="absolute top-3 right-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/90 text-slate-900 text-xs font-bold shadow hover:bg-white">
          {muted ? <><VolumeX className="w-4 h-4" />Tap for sound</> : <><Volume2 className="w-4 h-4" />Sound on</>}
        </button>
        <Link to={`/videos/${v.slug}`} className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-black/55 text-white text-xs font-semibold hover:bg-black/75" data-testid="hero-video-title">
          <Play className="w-3 h-3" />{v.title}
        </Link>
      </div>
    </div>
  );
};

export default HeroVideo;
